// extracted by mini-css-extract-plugin
export default {"profilesLabel":"profilesLabel---xEeel","profilesPopoverContent":"profilesPopoverContent---biBlS"};